module.exports = __webpack_public_path__ + "static/media/ice.d9bd6a3d.svg";